import React, { useCallback, useEffect,useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Card, CardBody, Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip } from 'reactstrap';

//import images
import miniral from "../../../assets/images/svg/miniral.svg";
import TableContainer from 'Components/Common/TableContainer';
import DeleteModal  from 'Components/Common/DeleteModal';
import { numberWithCommas } from "../../../helpers/globalHelper"
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useBasinFindAllQuery,useBasinUpdateMutation,useBasinCreateMutation,useBasinDeleteMutation, useBasinFindOneQuery } from 'store';
import ShapeUpload from 'Components/fileUpload/ShapeUpload';
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Spinners from "Components/Common/Spinner";

const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [basinCount, setBasinCount] = useState<any>();
  const [basinList, setBasinList] = useState<any>();
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();
  const [basinModalViewBackdrop, setBasinModalViewBackdrop] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<any>([])
  const [resetFiles, setResetFiles] = useState<any>([])
  const [baseMap, setBaseMap] = useState("voyager")
  const [customCenter, setCustomCenter] = useState<any>();
  const [isLoading, setLoading] = useState<any>(true);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [basinDataOne, setBasinDataOne] = useState<any>(null)  
  const [basinUptOne, setBasinUptOne] = useState<any>(null)  
  const [basinCreate, basinCreateResult] = useBasinCreateMutation();
  const [basinUpdate, basinUpdateResult] = useBasinUpdateMutation();
  const [basinDelete, basinDeleteResult] = useBasinDeleteMutation();

  const [deleteModal, setDeleteModal] = useState<any>(null);
  const {data:findOnedata, error  } = useBasinFindOneQuery(basinDataOne?.id);

  const {
    data: basinData,
    error: basinError,
    isFetching: isBasinFetching,
  } = useBasinFindAllQuery(customQuery);

  useEffect(()=>{
    setLoading(false)
    setBasinList(basinData?.data)
    setBasinCount(basinList?.length)
    setCustomPagination(basinData?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1} &pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [basinData, customQuery])

  const onClickDelete = (basinRowData) => {
    setBasinDataOne(basinRowData);
    setDeleteModal(true);
  };

  const handleDeleteBasin = () =>{
    if(basinDataOne){
      basinDelete(basinDataOne.id);
      setDeleteModal(false);
    }
  }
 
  const [modal_backdrop, setmodal_backdrop] = useState(false);

  const handleJobClick = useCallback((arg:any)=>{
    const basinTemp = arg;
    setBasinUptOne({
      id: basinTemp.id,
      basin_name: basinTemp.basin_name,
      basin_name_en: basinTemp.basin_name_en,
      taken_date: basinTemp.taken_date,
      taken_decree: basinTemp.taken_decree,
      area: basinTemp.area,
      
    });
    setIsEdit(true);
    toggle();
  }, []);

  useEffect(() =>{
    setBasinDataOne(findOnedata?.data)
    const tempCenter = { cusCenter: findOnedata?.data?.['geom']?.coordinates?.[0]?.[0]?.[0] };
    setCustomCenter(tempCenter)
  },[findOnedata])

  const handleJobClicks = () => {
      setIsEdit(false);
      toggle();
      setBasinDataOne(null);
      setBasinUptOne(null);
    };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: basinUptOne?.id,
      basin_name : basinUptOne?.basin_name,
      basin_name_en :basinUptOne?.basin_name_en,
      taken_date :basinUptOne?.taken_date,
      taken_decree :basinUptOne?.taken_decree,
      area :basinUptOne?.area,
      geom :basinUptOne?.geom,

    },
    validationSchema: Yup.object({
        basin_name: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
        basin_name_en: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
        taken_date: Yup.date().typeError("Огноо төрлийн оруулна уу !").required("Утга оруулна уу"),
        taken_decree: Yup.string().typeError("Утга сонгоно уу!").required("Утга оруулна уу"),
        area: Yup.number().typeError("Тоон төрлийн утга оруулна уу !").required("Утга оруулна уу"),
    }),
    
    onSubmit: (values: any) => {
      if (isEdit) {
        const formData = new FormData();
        formData.append('id', basinUptOne ? basinUptOne.id.toString() : '0');
        formData.append('basin_name', values?.basin_name);
        formData.append('basin_name_en', values?.basin_name_en);
        formData.append('taken_date', values?.taken_date);
        formData.append('taken_decree', values?.taken_decree);
        formData.append('area', values?.area);
        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }
       basinUpdate(formData)
       toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
       setResetFiles(true);
      }else{
        const formData = new FormData();
        formData.append('basin_name', values['basin_name'] || '');
        formData.append('basin_name_en', values['basin_name_en'] || '');
        formData.append('taken_date', values['taken_date'] || '');
        formData.append('taken_decree', values['taken_decree'] || '');
        formData.append('area', values['area'] || 0);

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }
        basinCreate(formData);
        toastr.success("Мэдээлэл амжилттай орлоо!", "Амжилттай");
        setResetFiles(true);
      }
      validation.resetForm();
      
      setmodal_backdrop(false)
      toggle();
      }
  });

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  function basinModal_backdrop(){
    setBasinModalViewBackdrop(!basinModalViewBackdrop);
    removeBodyCss();
           
  }
  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop);
    removeBodyCss();
  }

  const toggle = useCallback(() => {
      if (modal_backdrop) {
        setmodal_backdrop(false);
      } else {
        setmodal_backdrop(true);
      }
      setBasinDataOne(null)
    }, [modal_backdrop]);

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
     
      {
        header: "Нэр",
        accessorKey: "basin_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Англи нэр',
        accessorKey: "basin_name_en",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Огноо',
        accessorKey: "taken_date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Тушаал',
        accessorKey: "taken_decree",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Байршил',
        accessorKey: "area",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <a onClick={(event:any)=>{
                  setBasinDataOne(cellProps.row.original);
                  basinModal_backdrop();
                }} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </a>
                 <UncontrolledTooltip placement="top" target="viewtooltip">
                Харах
              </UncontrolledTooltip>
              </li>
             
               <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const basinData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(basinData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
                <li>
                  <Link
                    to="#"
                    className="btn btn-sm btn-soft-danger"
                    onClick={(event: any) => {
                      const basinRowData = cellProps.row.original;
                      event.preventDefault();
                      onClickDelete(basinRowData);
                    }}
                  >
                    <i className="mdi mdi-delete-outline" id="deletetooltip" />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
            </ul>
          );
        }
      },
    ],
    [handleJobClick]
  );
  return (
    <React.Fragment>
    <DeleteModal
        deleteName={basinDataOne?.basin_name}
        show={deleteModal}
        onDeleteClick={handleDeleteBasin}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={12}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={miniral} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(1644)}</span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  handleJobClicks();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
              </button>
            </div>
          </CardBody>
          <CardBody>
             {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
              <TableContainer
                columns={columns}
                data={basinList || ""}
                isCustomPageSize={true}
                isGlobalFilter={true}
                isPagination={true}
                colWidth={3}
                SearchPlaceholder="Сав газар хайх . . ."
                tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                pagination="pagination"
                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
              />
            }
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}

        backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          toggle();
        }}>
          <div className="h5 modal-title" id="staticBackdropLabel">{!!isEdit ? "Сав газрын хил мэдээлэл засах" : "Сав газрын хил мэдээлэл нэмэх"}</div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">Нэр*</Label>
                  <Input
                    name="basin_name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.basin_name || ""}
                    invalid={
                      validation.touched.basin_name && validation.errors.basin_name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.basin_name && validation.errors.basin_name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.basin_name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Гадаад нэр</Label>
                  <Input
                    name="basin_name_en"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.basin_name_en || ""}
                    invalid={
                      validation.touched.basin_name_en &&
                        validation.errors.basin_name_en
                        ? true
                        : false
                    }
                  />
                  {validation.touched.basin_name_en &&
                    validation.errors.basin_name_en ? (
                    <FormFeedback type="invalid">
                      {validation.errors.basin_name_en}
                    </FormFeedback>
                  ) : null}
                </div>
               
                 <div className="mb-3">
                    <Label>Огноо</Label>
                    <Input
                      name="taken_date"
                      type="date"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.taken_date || ""}
                      invalid={
                        validation.touched.taken_date && validation.errors.taken_date
                          ? true
                          : false
                      }
                    >
                    </Input>
                    {validation.touched.taken_date &&
                      validation.errors.taken_date ? (
                      <FormFeedback type="invalid">
                        {validation.errors.taken_date}
                      </FormFeedback>
                    ) : null}
                  </div>
              </Col>
              <Col lg={6}>
                 
                  <div className="mb-3">
                    <Label>Тушаал</Label>
                    <Input
                      name="taken_decree"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.taken_decree || ""}
                      invalid={
                        validation.touched.taken_decree && validation.errors.taken_decree
                          ? true
                          : false
                      }
                    />
                    {validation.touched.taken_decree && validation.errors.taken_decree ? (
                      <FormFeedback type="invalid">
                        {validation.errors.taken_decree}
                      </FormFeedback>
                    ) : null}
                  </div>
                
                  <div className="mb-3">
                    <Label>Байршил</Label>
                    <Input
                      name="area"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.area || ""}
                      invalid={
                        validation.touched.area && validation.errors.area
                          ? true
                          : false
                      }
                    ></Input>
                    {validation.touched.area && validation.errors.area ? (
                      <FormFeedback area="invalid">
                        {validation.errors.area}
                      </FormFeedback>
                    ) : null}
                  </div>
              </Col>
            </Row>
           <Row>
              <ShapeUpload selectFiles = {(e)=>{
                console.log(e);
                setSelectedFiles(e);
                }} onReset={resetFiles} onResetValueChange={setResetFiles} />
            </Row>
              {/* <Row>
              <Col lg={12}>
                <div className='mapTypeSelection'>
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                </div>
                <MainMap baseMap={baseMap} results={basinOne?.['geom']} customCenter={customCenter} zoomChange={7} />
              </Col>

            </Row> */}
           {/* ):null} */}
            

          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary">Хадгалах</button>
          </div>
        </Form>

      </Modal>

      <Modal 
      size="xl"
      isOpen={basinModalViewBackdrop}
      toggle={()=>{
        basinModal_backdrop();
      }}
      // backdrop={'static'}
      id="staticBackdrop"
      centered
      >
        <ModalHeader toggle={()=>{
          basinModal_backdrop();
        }}>
          <div className='h5 modal-title' id="staticBackdropLabel">Усны сав газрын хил</div>
        </ModalHeader>
        <Form onSubmit={(e)=>{
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>Нэр </Label>
                  <Input
                    name="basin_name"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={basinDataOne?.basin_name}
                  />
                </div>
                 <div className="mb-3">
                  <Label>Гадаад нэр </Label>
                  <Input
                    name="basin_name_en"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={basinDataOne?.basin_name_en}
                  />
                </div>
                 <div className="mb-3">
                  <Label>Огноо </Label>
                  <Input
                    name="taken_date"
                    type="date"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={basinDataOne?.taken_date}
                  />
                </div>
                </Col>
               <Col lg={6}>
                 <div className="mb-3">
                  <Label>Тушаал </Label>
                  <Input
                    name="taken_decree"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={basinDataOne?.taken_decree}
                  />
                </div>
                 <div className="mb-3">
                  <Label>Байршил </Label>
                  <Input
                    name="area"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={basinDataOne?.area}
                  />
                </div>
              </Col>
            </Row>
            {basinDataOne?.['geom'] ?(
            <Row>
              <Col lg={12}>
                <div className='mapTypeSelection'>
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                </div>
                <MainMap baseMap={baseMap} results={basinDataOne?.['geom']} customCenter={customCenter} zoomChange={7} />
                
              </Col>
              </Row>):null}
          </ModalBody>
        </Form>
        
      </Modal>
    </React.Fragment>
  );
}

export default Detail;